import Axios from "axios";

let timeout;

export default class Search {
    constructor() {
        const searchinputs = document.querySelectorAll('.query');

        if (searchinputs) {
            searchinputs.forEach(searchinput => {
                searchinput.addEventListener('keyup', (e) => {
                    if (e.which !== 13) {
                        if (timeout) {
                            clearTimeout(timeout);
                        }
                        timeout = setTimeout(() => {
                            this.autocomplete(searchinput);
                        }, 700);

                    }
                });
            })
        }
    }

    autocomplete(search) {
        const wrapper = search.nextElementSibling;
        const results = wrapper.querySelector('ul.foundresults');
        const pending = wrapper.querySelector('ul.pending');
        const value = search.value;
        const plaatsInput = document.getElementById('plaatsInput');
        console.log(plaatsInput);

        if (value.length > 0) {
            if (request) {
                request.abort();
            }

            const request = require('axios');

            request.interceptors.request.use(config => {
                results.style.display = 'none';
                pending.style.display = 'block';
                wrapper.style.opacity = '1';
                wrapper.style.display = 'block';

                return config;
            }, error => {
                return Promise.reject(error);
            });

            request.get('/properties/autocomplete', {
                headers: {
                    'Content-Type': 'application/json',
                },
                params: {
                    q: value
                }
            })
                .then((response) => {
                    pending.style.display = 'none';
                    results.style.display = 'block';

                    results.querySelectorAll('li').forEach(li => {
                        li.remove();
                    });

                    const {data} = response;

                    if (data.length) {
                        data.forEach((result, i) => {
                            let inputValue;
                            let liValue;
                            const li = document.createElement('li');
                            li.classList.add('list-group-item');
                            if (result.type === 'straat') {
                                // inputValue = result.string + ' (' + result.city + ')';
                                inputValue = result.string;
                                liValue = result.string + ' (' + result.city + ')<br><small>' + result.type + '</small>';
                            }else if (result.type === 'postcode') {
                                inputValue = result.string;
                                liValue = result.string + ' (' + result.city + ')<br><small>' + result.type + '</small>';
                            } else {
                                inputValue = result.string;
                                liValue = result.string + '<br><small>' + result.type + '</small>';
                            }
                            li.innerHTML = liValue;
                            li.setAttribute('data-search', result.string);
                            li.setAttribute('data-city', result.city);

                            results.append(li);

                            li.addEventListener('click', (ev) => {
                                // const search = document.querySelector('#query');
                                search.value = inputValue;
                                plaatsInput.value = li.dataset.city;
                                wrapper.style.display = 'none';
                                results.style.display = 'none';
                            });
                        });
                    } else {
                        const li = document.createElement('li');
                        li.classList.add('list-group-item');
                        li.innerHTML = 'Geen resultaten gevonden...';

                        results.append(li);
                    }
                });
        }
    }

}
